var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket" },
    [
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row head" }, [
        _c("div", { staticClass: "col col-80" }, [
          _vm._v(_vm._s(_vm.ticket.subject))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col col-20" }, [
          _c("span", {
            staticClass: "status",
            class: "status--" + _vm.ticket.statusId
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row ticket-chat" }, [
        _c("div", { staticClass: "col col-100" }, [
          _c("div", { staticClass: "message" }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.ticket.message) } }),
            _vm._v(" "),
            _c("div", { staticClass: "time" }, [
              _vm._v(_vm._s(_vm.ticket.creationTime))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.conversation, function(item, index) {
        return _c("div", { staticClass: "row ticket-chat" }, [
          _c("div", { staticClass: "col col-100" }, [
            _c(
              "div",
              { staticClass: "message", class: { employee: item.isEmployee } },
              [
                _c("div", { domProps: { innerHTML: _vm._s(item.message) } }),
                _vm._v(" "),
                _c("div", { staticClass: "time" }, [
                  _vm._v(_vm._s(item.creationTime))
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clear" }),
            _vm._v(" "),
            item.statusChange
              ? _c("div", [
                  _c("div", { staticClass: "status-change" }, [
                    _vm._v("De status is gewijzigd naar "),
                    _c("b", [_vm._v(_vm._s(item.statusChange))])
                  ])
                ])
              : _vm._e()
          ])
        ])
      }),
      _vm._v(" "),
      _vm.ticket.locked != 1
        ? _c("div", { staticClass: "new-message" }, [
            _vm.$root.app.platform == "android"
              ? _c("div", { staticClass: "row row-last setting" }, [
                  _c("div", { staticClass: "col col-80" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: { "form-group--error": _vm.$v.newMessage.$error }
                      },
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newMessage,
                              expression: "newMessage"
                            }
                          ],
                          staticClass:
                            "form__input form__textarea form__textarea--small",
                          attrs: {
                            type: "text",
                            placeholder: "Typ hier je bericht"
                          },
                          domProps: { value: _vm.newMessage },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.newMessage = $event.target.value
                              },
                              function($event) {
                                return _vm.$v.newMessage.$touch()
                              }
                            ]
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col col-20 new-message__btn",
                      on: {
                        click: function($event) {
                          return _vm.submit()
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/ticket-submit.svg",
                          width: "21",
                          height: "19"
                        }
                      })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$root.app.platform == "ios"
              ? _c("div", { staticClass: "row row-last setting" }, [
                  _c("div", { staticClass: "col col-100" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: { "form-group--error": _vm.$v.newMessage.$error }
                      },
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newMessage,
                              expression: "newMessage"
                            }
                          ],
                          staticClass:
                            "form__input form__textarea form__textarea--small",
                          attrs: {
                            type: "text",
                            placeholder: "Typ hier je bericht"
                          },
                          domProps: { value: _vm.newMessage },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.newMessage = $event.target.value
                              },
                              function($event) {
                                return _vm.$v.newMessage.$touch()
                              }
                            ]
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col col-100" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        on: {
                          click: function($event) {
                            return _vm.submit()
                          }
                        }
                      },
                      [_vm._v("Bericht versturen")]
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.$v.newMessage.required
                    ? _c("span", { staticClass: "form-group__message" }, [
                        _vm._v("Veld is verplicht")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.newMessage.minLength
                    ? _c("span", { staticClass: "form-group__message" }, [
                        _vm._v(
                          "Bericht dient minimaal " +
                            _vm._s(_vm.$v.form.message.$params.minLength.min) +
                            " tekens te bevatten."
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45b3f138", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45b3f138","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tickets/Ticket.vue
// module id = null
// module chunks = 